import Header from "@/components/Header";
import Hero from "@/components/Hero";
import GameCategories from "@/components/GameCategories";
import FeaturedGames from "@/components/FeaturedGames";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background font-['Inter']">
      <Header />
      <main className="pt-16 md:pt-20">
        <Hero />
        <GameCategories />
        <FeaturedGames />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
